export function isBidvBank(name: string): boolean {
  return String(name ?? '').toUpperCase().includes('BIDV');
}

export function isBvBank(name: string): boolean {
  const u = String(name ?? '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');
  return u === 'BVBANK' || u === 'VCCB' || u.includes('BVBANK') || u.includes('VIETCAPITAL') || u.includes('BANVIET');
}

export function supportsQrAccountSwitch(name: string): boolean {
  return isBidvBank(name) || isBvBank(name);
}

export function qrAccountModeForBank(bank: string, mode: 'virtual' | 'primary' | string | undefined): 'virtual' | 'primary' {
  return supportsQrAccountSwitch(bank) && mode === 'primary' ? 'primary' : 'virtual';
}

export function qrAccountFieldsError(
  bank: string,
  virtual: string,
  primary: string,
  mode: 'virtual' | 'primary' | string | undefined,
): string | null {
  const m = qrAccountModeForBank(bank, mode);
  if (m === 'primary' && !String(primary ?? '').trim()) {
    return isBvBank(bank)
      ? 'Для BV Bank в режиме «Основной» заполните основной счёт'
      : 'Для BIDV в режиме «Основной» заполните основной счёт';
  }
  const virtualRequired = !(isBvBank(bank) && m === 'primary');
  if (virtualRequired && !String(virtual ?? '').trim()) {
    return supportsQrAccountSwitch(bank) ? 'Заполните виртуальный счёт' : 'Заполните номер счёта';
  }
  return null;
}

export function nextQrAccountMode(
  prevBank: string,
  nextBank: string,
  prevMode: 'virtual' | 'primary' | string | undefined,
): 'virtual' | 'primary' {
  if (!supportsQrAccountSwitch(nextBank)) return 'virtual';
  if (isBvBank(nextBank) && !supportsQrAccountSwitch(prevBank)) return 'primary';
  return prevMode === 'primary' ? 'primary' : 'virtual';
}
